.profileSegment {
  color: var(--mantine-color-brand-9);
  font-weight: 700;
  font-size: var(--mantine-font-size-sm);
  background: transparent;
  border: 1px solid transparent;
  cursor: pointer;
}

.profileSegmentActive {
  color: var(--mantine-color-black);
  font-weight: 700;
  font-size: var(--mantine-font-size-sm);
  background-color: var(--mantine-color-white);
  border: 1px solid var(--mantine-color-brand-1);
  cursor: pointer;
}
